<red-header></red-header>
<red-page-content>
  <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
    <div class="tw:flex tw:min-h-full tw:w-full tw:flex-col tw:items-center tw:justify-center tw:gap-4 tw:px-4 tw:py-8">
      <h1 class="tw:block tw:text-xl">
        <ion-text color="primary" class="tw:font-bold">Login</ion-text>
      </h1>
      <p class="md:tw:w-2/3 tw:w-full tw:text-center tw:text-sm">Enter your <b>username and password</b>.</p>
      <div class="md:tw:w-2/3 tw:w-full">
        <ion-list [inset]="true" lines="full" class="no-last-line">
          <ion-item>
            <ion-input
              [redErrorMessage]="loginFormValidationErrors['username']"
              labelPlacement="stacked"
              inputmode="text"
              [required]="true"
              type="text"
              formControlName="username"
            >
              <div slot="label">Username:<ion-text color="danger">*</ion-text></div>
            </ion-input>
          </ion-item>
          <ion-item>
            <ion-input
              [redErrorMessage]="loginFormValidationErrors['password']"
              type="password"
              labelPlacement="stacked"
              inputmode="text"
              [required]="true"
              formControlName="password"
            >
              <ion-input-password-toggle slot="end"></ion-input-password-toggle>
              <div slot="label">Password:<ion-text color="danger">*</ion-text></div>
            </ion-input>
          </ion-item>
        </ion-list>
      </div>
      <div class="md:tw:w-2/3 tw:w-full tw:px-4">
        <ion-button color="primary" expand="block" type="submit" [disabled]="loginForm.invalid">
          Next<ion-icon name="chevron-forward-outline"></ion-icon>
        </ion-button>
      </div>
      <div class="md:tw:w-2/3 tw:w-full tw:px-4">
        <ion-button color="primary" fill="outline" expand="block" (click)="onHelp()">
          <ion-icon name="help-circle-outline"></ion-icon>Help
        </ion-button>
      </div>
    </div>
  </form>
</red-page-content>
